import { ElementAttribute } from "../../../dom-tools/ElementAttribute";
import { ElementType } from "../../../dom-tools/ElementType";
import { Range } from "../../../geometry/Range";
import { MathX } from "../../../math/MathX";
import { TextFX } from "../TextFX";
import { TextFXElement } from "../TextFXElement";
import { TextFXLetter } from "../TextFXLetter";
import { TextFXModule, TextFXModuleSettings } from "../TextFXModule";

export class FadingTextFXSettings extends TextFXModuleSettings
{
  value:Range;
  byPosition:number;
  duration:Range;
  delay:Range;
}

export class OpacityFadingTextFX extends TextFXModule
{
  static readonly elementType    = new ElementType( "text--fx-opacity-fading");

  static readonly value     = new ElementAttribute( "value" );
  static readonly byPosition = new ElementAttribute( "by-position" );
  static readonly duration   = new ElementAttribute( "duration" );
  static readonly delay      = new ElementAttribute( "delay" );

  get type() { return OpacityFadingTextFX.elementType; }

  getSettings( element:Element )
  {
    let settings = new FadingTextFXSettings();
    settings.module = this;
    
    settings.value       = OpacityFadingTextFX.value.asRange( element );
    settings.byPosition  = OpacityFadingTextFX.byPosition.asNumberFrom( element );
    settings.duration    = OpacityFadingTextFX.duration.asRange( element );
    settings.delay       = OpacityFadingTextFX.delay.asRange( element );

    return settings;
  }

 
  apply( letter:TextFXLetter[], settings:TextFXModuleSettings )
  {
    let fadingSettings = settings as FadingTextFXSettings;
    letter.forEach( l => this.#applyOnLetter( l,  fadingSettings ) );
  }

  
  #applyOnLetter( textLetter:TextFXLetter, settings:FadingTextFXSettings )
  {    
    let element  = textLetter.element as HTMLElement;
    let position = textLetter.letterPosition;  

    let fadeByPositionValue = settings.byPosition >= 0 ?  
                                MathX.lerp( 1, position, settings.byPosition ) :
                                MathX.lerp( position, 1, -settings.byPosition );
    
    let value   = TextFX.random.in( settings.value );
    let fadeDuration  = TextFX.random.in( settings.duration ) * fadeByPositionValue;
    let delayDuration = TextFX.random.in( settings.delay ) * fadeByPositionValue;
    
    textLetter.setTransition( "opacity", fadeDuration, delayDuration );

    element.style.opacity = value + "";
  }


}